export default "__VITE_ASSET__WbJKi6ag__"